mutation addCommentary($leadId: String!, $text: String!) {
  response: addCommentary(leadId: $leadId, text: $text)
}
